export default __webpack_public_path__ + "static/media/subtraction.d6fed340.svg";